export default __webpack_public_path__ + "static/media/ad.e6792a08.png";